import * as React from 'react'

function SvgUsdLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_10365_164536)">
        <path
          d="M8.99976 18C13.9703 18 17.9998 13.9706 17.9998 9C17.9998 4.02944 13.9703 0 8.99976 0C4.02919 0 -0.000244141 4.02944 -0.000244141 9C-0.000244141 13.9706 4.02919 18 8.99976 18Z"
          fill="#F0F0F0"
        />
        <path
          d="M8.60864 9.00019H17.9999C17.9999 8.18786 17.8917 7.40093 17.6899 6.65234H8.60864V9.00019Z"
          fill="#D80027"
        />
        <path
          d="M8.60864 4.30438H16.679C16.128 3.40537 15.4236 2.61073 14.6023 1.95654H8.60864V4.30438Z"
          fill="#D80027"
        />
        <path
          d="M9.00006 18C11.1182 18 13.065 17.2679 14.6024 16.0435H3.39771C4.93509 17.2679 6.88193 18 9.00006 18Z"
          fill="#D80027"
        />
        <path
          d="M1.32098 13.6955H16.6791C17.1214 12.9738 17.4644 12.1849 17.69 11.3477H0.310059C0.535656 12.1849 0.878676 12.9738 1.32098 13.6955Z"
          fill="#D80027"
        />
        <path
          d="M4.16872 1.40548H4.98888L4.22599 1.95971L4.5174 2.85652L3.75455 2.30228L2.99169 2.85652L3.24341 2.08178C2.57172 2.64129 1.98299 3.29681 1.49783 4.02722H1.76063L1.27501 4.38001C1.19936 4.50622 1.12679 4.63444 1.05726 4.76455L1.28915 5.47826L0.856514 5.16393C0.748971 5.39177 0.650604 5.62475 0.562186 5.86259L0.817666 6.64896H1.76063L0.997736 7.2032L1.28915 8.1L0.526291 7.54576L0.0693301 7.87778C0.0235918 8.24544 -0.000244141 8.61993 -0.000244141 9H8.99976C8.99976 4.02947 8.99976 3.44348 8.99976 0C7.22183 0 5.56446 0.515742 4.16872 1.40548ZM4.5174 8.1L3.75455 7.54576L2.99169 8.1L3.2831 7.2032L2.52021 6.64896H3.46317L3.75455 5.75216L4.04592 6.64896H4.98888L4.22599 7.2032L4.5174 8.1ZM4.22599 4.58146L4.5174 5.47826L3.75455 4.92402L2.99169 5.47826L3.2831 4.58146L2.52021 4.02722H3.46317L3.75455 3.13042L4.04592 4.02722H4.98888L4.22599 4.58146ZM7.74566 8.1L6.98281 7.54576L6.21995 8.1L6.51136 7.2032L5.74847 6.64896H6.69143L6.98281 5.75216L7.27418 6.64896H8.21714L7.45425 7.2032L7.74566 8.1ZM7.45425 4.58146L7.74566 5.47826L6.98281 4.92402L6.21995 5.47826L6.51136 4.58146L5.74847 4.02722H6.69143L6.98281 3.13042L7.27418 4.02722H8.21714L7.45425 4.58146ZM7.45425 1.95971L7.74566 2.85652L6.98281 2.30228L6.21995 2.85652L6.51136 1.95971L5.74847 1.40548H6.69143L6.98281 0.508676L7.27418 1.40548H8.21714L7.45425 1.95971Z"
          fill="#0052B4"
        />
      </g>
      <defs>
        <clipPath id="clip0_10365_164536">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgUsdLogo
